import { IImage } from "@faire/web-api/indigofair/data/IImage";

import { IShowroomProductMedia } from "@faire/retailer/views/product/ProductImages/utils";

export const productMediaFromImages = (
  images: IImage[]
): IShowroomProductMedia[] =>
  images.map((image, index) => ({
    image,
    index,
    isVideo: false,
  }));

export const getMediaToken = (media?: IShowroomProductMedia) => {
  if (media) {
    return media.isVideo ? media.video.token : media.image.token;
  }
  return undefined;
};
